export default __webpack_public_path__ + "static/media/6f1c7e5c0e9e8a93e10c905885168b90.svg";